import SandglassIcon from '~domains/partner-application/shared/assets/icons/sandglass.svg?react';
import { StatusScreenContent } from '~domains/partner-application/shared/ui/status-screen-content';

import { ScreenHeader, Screen } from '~shared/ui/screen';

export const SignedScreen = () => {
  return (
    <Screen header={<ScreenHeader singleLogoAlign="left" />}>
      <StatusScreenContent
        icon={<SandglassIcon />}
        title={<>Please wait a&nbsp;moment…</>}
        description={
          <>
            We&#39;re creating your personal account. This usually takes
            a&nbsp;few minutes.
          </>
        }
        action={{
          label: 'Refresh',
          onClick: () => {
            window.location.reload();
          },
        }}
      />
    </Screen>
  );
};
